// src/components/PerformanceCards.js
import { Card, CardContent } from "@mui/material";

export default function PerformanceCards({ data }) {
  const metrics = [
    { label: "Leads Added", value: data?.leads_added || 0 },
    { label: "Leads Closed", value: data?.leads_closed || 0 },
    { label: "Follow-ups", value: data?.followups_completed || 0 },
    { label: "Conversion Rate", value: `${data?.conversion_rate || 0}%` },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
      {metrics.map((m) => (
        <Card key={m.label} className="bg-background shadow-md">
          <CardContent className="p-4 text-center">
            <div className="text-sm text-muted-foreground">{m.label}</div>
            <div className="text-2xl font-bold">{m.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
